import { getSubDomain, getDomain, getTld } from './internal';
export function getFullUrl(subDomainPrefix, overrideConfig) {
  var subDomain = getSubDomain(subDomainPrefix, overrideConfig);
  var domain = getDomain(overrideConfig);
  var tld = getTld(overrideConfig);
  return "https://" + subDomain + "." + domain + "." + tld;
}